import React from 'react';
import { Button, Space, Typography } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';

const { Text } = Typography;

export type CompositionHeaderCommand = {
  key: string;
  label: string;
  onClick: () => void;
  loading?: boolean;
  type?: 'primary' | 'default';
  testId?: string;
};

export type CompositionHeaderProps = {
  title?: string;
  commands?: CompositionHeaderCommand[];
};

/**
 * Header command surface — renders callbacks only, no business rules.
 */
const CompositionHeader: React.FC<CompositionHeaderProps> = ({
  title = 'Состав комплекта',
  commands = [],
}) => (
  <div className="cp-composition__header-main">
    <Text strong className="cp-composition__title">
      {title}
    </Text>
    {commands.length > 0 ? (
      <Space size={8} wrap>
        {commands.map((command) => (
          <Button
            key={command.key}
            size="small"
            type={command.type ?? 'default'}
            icon={command.key === 'initialize' ? <ThunderboltOutlined /> : undefined}
            onClick={command.onClick}
            loading={command.loading}
            data-testid={command.testId}
          >
            {command.label}
          </Button>
        ))}
      </Space>
    ) : null}
  </div>
);

export default CompositionHeader;
